const red = "red lighten-2";
const green = "green darken-1";

export default {
  multimodal: {
    variants: [
      { id: 0, title: "Нет", color: green },
      { id: 1, title: "Да", color: red },
    ],
  },
  invoice: {
    variants: [
      { id: 0, title: "Нет", color: red },
      { id: 1, title: "Есть", color: green },
      { id: 2, title: "Без документов", color: red },
    ],
  },
  ex: {
    group: true,
    value: {
      exWhoDoing: {
        variants: [
          { id: 2, title: "Фабрикa" },
          { id: 3, title: "Делает склад" },
          { id: 4, title: "Экспедиция" },
          { id: 5, title: "Без док-тов" },
          { id: 6, title: "Без EX" },
        ],
      },
      exDocumentInSystem: {
        variants: [
          { id: 0, title: "Нет в системе", color: red },
          { id: 1, title: "Есть в системе", color: green },
        ],
      },
    },
  },
  description: {
    variants: [
      { id: 0, title: "Нет", color: red },
      { id: 1, title: "Есть", color: green },
    ],
  },
  damage: {
    variants: [
      { id: 0, title: "Нет", color: green },
      { id: 1, title: "Есть", color: red },
    ],
  },
  attention: {
    variants: [
      { id: 0, title: "Нет", color: green },
      { id: 1, title: "Есть", color: red },
    ],
  },
  packingMethod: {
    variants: [
      { id: 0, title: "Не паллеты", color: red },
      { id: 1, title: "Паллеты", color: green },
    ],
  },
  oversized: {
    variants: [
      { id: 0, title: "Нет", color: green },
      { id: 1, title: "Да", color: red },
    ],
  },
  fragile: {
    variants: [
      { id: 0, title: "Нет", color: green },
      { id: 1, title: "Да", color: red },
    ],
  },
  mesurable: {
    variants: [
      { id: 0, title: "Нет", color: red },
      { id: 1, title: "Да", color: green },
    ],
  },
  giveAway: {
    variants: [
      { id: 0, title: "Нет", color: red },
      { id: 1, title: "Да", color: green },
    ],
  },
  cargoRepacked: {
    variants: [
      { id: 0, title: "Нет", color: red },
      { id: 1, title: "Да", color: green },
    ],
  },
  claim: {
    variants: [{ id: 0, title: "Нет" }, { id: 1, title: "Да", color: red }],
  },
  isFullBatch: {
    variants: [
      { id: 0, title: "Нет", color: red },
      { id: 1, title: "Да", color: green },
    ],
  },
};
